module.exports = __webpack_public_path__ + "static/media/panel_bottom_right.c82fef1d.png";